// extracted by mini-css-extract-plugin
export default {"root":"UserStatusDetailsContainer-root-97f0f3ae719687c312f51241d24503bc"};